// extracted by mini-css-extract-plugin
module.exports = {"footerTableTotal":"billingOrders_footerTableTotal__scUz3","customList":"billingOrders_customList__qw6xL","customListRow":"billingOrders_customListRow__19umG"};